<template>
    <div class="download-app-button" @click.prevent="showDownloadAppContainer">
        <a href="#">{{ text }} <slot></slot></a>
    </div>
</template>

<script>
    import { isAndroid, isIOS } from 'mobile-device-detect';
    import {redirectToAppstore} from "../helper";

    export default {
        props: {
            text: String
        },

        data(){
            return {

            }
        },

        computed: {

        },

        methods: {
            showDownloadAppContainer(){
                if(isAndroid || isIOS){
                    return redirectToAppstore();
                }else {
                    this.$events.$emit('download-app-container:toggle');
                }
            }
        },

        mounted() {

        }
    }
</script>

<style scoped lang="scss">
    .download-app-button{
        display: inline-block;

        a{
            color: inherit;
        }
    }
</style>
